import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import { StyledSectionContainer } from '../../../../globalStyled';
import { fontUi, sectionTitle } from '../../../../theme/typography';

export const StyledLoader = styled(Loader)`
  position: fixed;
  top: 50%;
  left: 25%;
  transform: translate(-25%, -50%);
`;

export const StyledTextArrow = styled.div`
  position: relative;
`;

export const StyledRevenueSection = styled(StyledSectionContainer)`
  overflow: hidden;

  h3 {
    ${sectionTitle};
    width: 100%;
    font-size: 18px;
    border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
    padding: 16px 16px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;

export const StyledRevenue = styled.div`
  padding: 8px 16px 16px;
  background: transparent;
  display: block;
`;

export const StyledInfoInRevenue = styled.div`
  ${fontUi};
  padding: 0 4px;
  margin: 12px 0;
  color: ${({ theme }) => theme.text};

  &:last-of-type {
    h4 span {
      text-decoration-line: underline;
    }
  }
  h4,
  ul li {
    span {
      &[data-total-sign='positive'] {
        &:before {
          margin-right: 0px;
          content: '+';
          ${fontUi};
          font-weight: 500;
          font-size: 14px;
          line-height: 26px;
          color: ${({ theme }) => theme.success};
        }
      }
      &.money-amount {
        &[data-total-sign='positive'] {
          color: ${({ theme }) => theme.success};
        }

        &[data-total-sign='negative'] {
          color: ${({ theme }) => theme.danger};
        }
      }
    }
  }
  h4 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${fontUi};
    font-weight: 600;
    font-size: 15px;
    line-height: 100%;
    color: ${({ theme }) => theme.text};
    span {
      ${fontUi};
      font-weight: 700;
      font-size: 15px;
      line-height: 15px;
      color: ${({ theme }) => theme.text};
    }
  }
  &[data-total-sign='negative'] {
    h4 {
      span {
        color: ${({ theme }) => theme.danger};
        text-decoration-line: none;
      }
    }
  }
  ul > li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${fontUi};
    font-weight: 500;
    font-size: 13px;
    line-height: 100%;
    color: ${({ theme }) => theme.textMuted};
    padding: 12px 0;
    list-style-type: none;
    span {
      ${fontUi};
      font-weight: 500;
      font-size: 13px;
      line-height: 26px;
      color: ${({ theme }) => theme.text};
    }
  }
`;

export const StyledMarkedTitle = styled.div`
  background-color: ${({ theme }) => theme.hover};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  h3 {
    ${fontUi};
    font-weight: 700;
    font-size: 15px;
    padding: 0;
    border: 0;
    color: ${({ theme }) => theme.text};
  }
`;

export const StyledCashValue = styled.span`
  ${fontUi};
  font-weight: 600;
  font-size: 15px;
  color: ${({ theme }) => theme.text};
`;
